import { Box } from '@mui/material'

const sizeMap = {
  small: 32,
  medium: 40,
  large: 160,
}

export const EMOJI_SIZES = Object.keys(sizeMap)

export type EmojiSize = keyof typeof sizeMap

export interface EmojiProps {
  icon: string
  filled?: boolean
  completed?: boolean
  padded?: boolean
  size?: EmojiSize
}
export const Emoji = ({
  icon,
  filled = false,
  completed = false,
  padded = false,
  size: propSize = 'small',
}: EmojiProps) => {
  const size = sizeMap[propSize]

  const fontSize = padded ? size - 8 - 4 : size

  return (
    <Box
      display="inline-flex"
      justifyContent="center"
      alignItems="center"
      height={size}
      width={size}
      lineHeight={1}
      fontSize={fontSize}
      borderRadius={2}
      sx={theme => ({
        backgroundColor: filled ? theme.states.primary.selected : 'inherit',
        border: completed ? `2px solid ${theme.palette.primary.main}` : 'none',
      })}
    >
      {icon}
    </Box>
  )
}
